"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Focus = exports.Shadow = exports.ComponentColor = exports.BackgroundColor = exports.BorderColor = exports.TextColor = exports.Gradient = exports.ThemeColor = exports.RootColor = exports.Spacing = exports.BorderRadius = exports.BorderWidth = exports.TextDecoration = exports.LineHeight = exports.TextCase = exports.FontSize = exports.FontWeight = exports.ComponentLayout = exports.Opacity = void 0;
var Opacity;
(function (Opacity) {
    Opacity["op0"] = "--op-0";
    Opacity["op25"] = "--op-25";
    Opacity["op50"] = "--op-50";
    Opacity["op75"] = "--op-75";
    Opacity["op100"] = "--op-100";
})(Opacity = exports.Opacity || (exports.Opacity = {}));
var ComponentLayout;
(function (ComponentLayout) {
    ComponentLayout["INPUT_HEIGHT_SM"] = "--component-layout--input-height-sm";
    ComponentLayout["INPUT_HEIGHT_MD"] = "--component-layout--input-height-md";
    ComponentLayout["INPUT_HEIGHT_LG"] = "--component-layout--input-height-lg";
    ComponentLayout["INPUT_ICON_SIZE_SM"] = "--component-layout--input-icon_size-sm";
    ComponentLayout["INPUT_ICON_SIZE_MD"] = "--component-layout--input-icon_size-md";
    ComponentLayout["INPUT_ICON_SIZE_LG"] = "--component-layout--input-icon_size-lg";
    ComponentLayout["PAGE_HEADER__PADDING_Y"] = "--component-layout--page-header-padding-y";
    ComponentLayout["DRAWER_WIDTH_SM"] = "--component-layout--drawer-width-sm";
    ComponentLayout["DRAWER_WIDTH_MD"] = "--component-layout--drawer-width-md";
    ComponentLayout["DRAWER_WIDTH_LG"] = "--component-layout--drawer-width-lg";
    ComponentLayout["DRAWER_WIDTH_XL"] = "--component-layout--drawer-width-xl";
})(ComponentLayout = exports.ComponentLayout || (exports.ComponentLayout = {}));
var FontWeight;
(function (FontWeight) {
    FontWeight["regular"] = "--fontweight-regular";
    FontWeight["medium"] = "--fontweight-medium";
    FontWeight["semibold"] = "--fontweight-semibold";
    FontWeight["bold"] = "--fontweight-bold";
})(FontWeight = exports.FontWeight || (exports.FontWeight = {}));
var FontSize;
(function (FontSize) {
    FontSize["fs1"] = "--fontsize-1";
    FontSize["fs2"] = "--fontsize-2";
    FontSize["fs3"] = "--fontsize-3";
    FontSize["fs4"] = "--fontsize-4";
    FontSize["fs5"] = "--fontsize-5";
    FontSize["fs6"] = "--fontsize-6";
    FontSize["fs7"] = "--fontsize-7";
    FontSize["fs8"] = "--fontsize-8";
    FontSize["fs9"] = "--fontsize-9";
    FontSize["fs10"] = "--fontsize-10";
    FontSize["fs11"] = "--fontsize-11";
    FontSize["fs12"] = "--fontsize-12";
    FontSize["fs13"] = "--fontsize-13";
    FontSize["fs14"] = "--fontsize-14";
    FontSize["fs15"] = "--fontsize-15";
})(FontSize = exports.FontSize || (exports.FontSize = {}));
var TextCase;
(function (TextCase) {
    TextCase["none"] = "--textcase-none";
    TextCase["uppercase"] = "--textcase-uppercase";
    TextCase["lowercase"] = "--textcase-lowercase";
    TextCase["capitalize"] = "--textcase-capitalize";
})(TextCase = exports.TextCase || (exports.TextCase = {}));
var LineHeight;
(function (LineHeight) {
    LineHeight["normal"] = "--lineheight-normal";
    LineHeight["sm"] = "--lineheight-sm";
})(LineHeight = exports.LineHeight || (exports.LineHeight = {}));
var TextDecoration;
(function (TextDecoration) {
    TextDecoration["none"] = "--textdecoration-none";
    TextDecoration["underline"] = "--textdecoration-underline";
})(TextDecoration = exports.TextDecoration || (exports.TextDecoration = {}));
var BorderWidth;
(function (BorderWidth) {
    BorderWidth["normal"] = "--borderwidth-normal";
    BorderWidth["bold"] = "--borderwidth-bold";
    BorderWidth["extraBold"] = "--borderwidth-extraBold";
})(BorderWidth = exports.BorderWidth || (exports.BorderWidth = {}));
var BorderRadius;
(function (BorderRadius) {
    BorderRadius["xs"] = "--borderradius-xs";
    BorderRadius["sm"] = "--borderradius-sm";
    BorderRadius["md"] = "--borderradius-md";
    BorderRadius["lg"] = "--borderradius-lg";
    BorderRadius["xl"] = "--borderradius-xl";
})(BorderRadius = exports.BorderRadius || (exports.BorderRadius = {}));
var Spacing;
(function (Spacing) {
    Spacing["sp0"] = "--spacing-0";
    Spacing["sp4"] = "--spacing-4";
    Spacing["sp8"] = "--spacing-8";
    Spacing["sp12"] = "--spacing-12";
    Spacing["sp16"] = "--spacing-16";
    Spacing["sp20"] = "--spacing-20";
    Spacing["sp24"] = "--spacing-24";
    Spacing["sp32"] = "--spacing-32";
    Spacing["sp40"] = "--spacing-40";
    Spacing["sp48"] = "--spacing-48";
    Spacing["sp64"] = "--spacing-64";
    Spacing["sp80"] = "--spacing-80";
    Spacing["sp96"] = "--spacing-96";
    Spacing["sp128"] = "--spacing-128";
    Spacing["sp160"] = "--spacing-160";
    Spacing["sp192"] = "--spacing-192";
    Spacing["sp224"] = "--spacing-224";
    Spacing["sp256"] = "--spacing-256";
})(Spacing = exports.Spacing || (exports.Spacing = {}));
exports.RootColor = {
    White: '--root-color--white',
    Black: '--root-color--black',
    Gray: {
        LIGHT_6: '--root-color--gray--light-6',
        LIGHT_5: '--root-color--gray--light-5',
        LIGHT_4: '--root-color--gray--light-4',
        LIGHT_3: '--root-color--gray--light-3',
        LIGHT_2: '--root-color--gray--light-2',
        LIGHT_1: '--root-color--gray--light-1',
        DEFAULT: '--root-color--gray--default',
        DARK_1: '--root-color--gray--dark-1',
        DARK_2: '--root-color--gray--dark-2',
        DARK_3: '--root-color--gray--dark-3',
        DARK_4: '--root-color--gray--dark-4',
    },
    Yellow: {
        LIGHT_6: '--root-color--yellow--light-6',
        LIGHT_5: '--root-color--yellow--light-5',
        LIGHT_4: '--root-color--yellow--light-4',
        LIGHT_3: '--root-color--yellow--light-3',
        LIGHT_2: '--root-color--yellow--light-2',
        LIGHT_1: '--root-color--yellow--light-1',
        DEFAULT: '--root-color--yellow--default',
        DARK_1: '--root-color--yellow--dark-1',
        DARK_2: '--root-color--yellow--dark-2',
        DARK_3: '--root-color--yellow--dark-3',
        DARK_4: '--root-color--yellow--dark-4',
    },
    Orange: {
        LIGHT_6: '--root-color--orange--light-6',
        LIGHT_5: '--root-color--orange--light-5',
        LIGHT_4: '--root-color--orange--light-4',
        LIGHT_3: '--root-color--orange--light-3',
        LIGHT_2: '--root-color--orange--light-2',
        LIGHT_1: '--root-color--orange--light-1',
        DEFAULT: '--root-color--orange--default',
        DARK_1: '--root-color--orange--dark-1',
        DARK_2: '--root-color--orange--dark-2',
        DARK_3: '--root-color--orange--dark-3',
        DARK_4: '--root-color--orange--dark-4',
    },
    Red: {
        LIGHT_6: '--root-color--red--light-6',
        LIGHT_5: '--root-color--red--light-5',
        LIGHT_4: '--root-color--red--light-4',
        LIGHT_3: '--root-color--red--light-3',
        LIGHT_2: '--root-color--red--light-2',
        LIGHT_1: '--root-color--red--light-1',
        DEFAULT: '--root-color--red--default',
        DARK_1: '--root-color--red--dark-1',
        DARK_2: '--root-color--red--dark-2',
        DARK_3: '--root-color--red--dark-3',
        DARK_4: '--root-color--red--dark-4',
    },
    Pink: {
        LIGHT_6: '--root-color--pink--light-6',
        LIGHT_5: '--root-color--pink--light-5',
        LIGHT_4: '--root-color--pink--light-4',
        LIGHT_3: '--root-color--pink--light-3',
        LIGHT_2: '--root-color--pink--light-2',
        LIGHT_1: '--root-color--pink--light-1',
        DEFAULT: '--root-color--pink--default',
        DARK_1: '--root-color--pink--dark-1',
        DARK_2: '--root-color--pink--dark-2',
        DARK_3: '--root-color--pink--dark-3',
        DARK_4: '--root-color--pink--dark-4',
    },
    Violet: {
        LIGHT_6: '--root-color--violet--light-6',
        LIGHT_5: '--root-color--violet--light-5',
        LIGHT_4: '--root-color--violet--light-4',
        LIGHT_3: '--root-color--violet--light-3',
        LIGHT_2: '--root-color--violet--light-2',
        LIGHT_1: '--root-color--violet--light-1',
        DEFAULT: '--root-color--violet--default',
        DARK_1: '--root-color--violet--dark-1',
        DARK_2: '--root-color--violet--dark-2',
        DARK_3: '--root-color--violet--dark-3',
        DARK_4: '--root-color--violet--dark-4',
    },
    Blue: {
        LIGHT_6: '--root-color--blue--light-6',
        LIGHT_5: '--root-color--blue--light-5',
        LIGHT_4: '--root-color--blue--light-4',
        LIGHT_3: '--root-color--blue--light-3',
        LIGHT_2: '--root-color--blue--light-2',
        LIGHT_1: '--root-color--blue--light-1',
        DEFAULT: '--root-color--blue--default',
        DARK_1: '--root-color--blue--dark-1',
        DARK_2: '--root-color--blue--dark-2',
        DARK_3: '--root-color--blue--dark-3',
        DARK_4: '--root-color--blue--dark-4',
    },
    Teal: {
        LIGHT_6: '--root-color--teal--light-6',
        LIGHT_5: '--root-color--teal--light-5',
        LIGHT_4: '--root-color--teal--light-4',
        LIGHT_3: '--root-color--teal--light-3',
        LIGHT_2: '--root-color--teal--light-2',
        LIGHT_1: '--root-color--teal--light-1',
        DEFAULT: '--root-color--teal--default',
        DARK_1: '--root-color--teal--dark-1',
        DARK_2: '--root-color--teal--dark-2',
        DARK_3: '--root-color--teal--dark-3',
        DARK_4: '--root-color--teal--dark-4',
    },
    Green: {
        LIGHT_6: '--root-color--green--light-6',
        LIGHT_5: '--root-color--green--light-5',
        LIGHT_4: '--root-color--green--light-4',
        LIGHT_3: '--root-color--green--light-3',
        LIGHT_2: '--root-color--green--light-2',
        LIGHT_1: '--root-color--green--light-1',
        DEFAULT: '--root-color--green--default',
        DARK_1: '--root-color--green--dark-1',
        DARK_2: '--root-color--green--dark-2',
        DARK_3: '--root-color--green--dark-3',
        DARK_4: '--root-color--green--dark-4',
    },
};
exports.ThemeColor = {
    Gray: {
        LIGHT_6: '--theme-color--gray--light-6',
        LIGHT_5: '--theme-color--gray--light-5',
        LIGHT_4: '--theme-color--gray--light-4',
        LIGHT_3: '--theme-color--gray--light-3',
        LIGHT_2: '--theme-color--gray--light-2',
        LIGHT_1: '--theme-color--gray--light-1',
        DEFAULT: '--theme-color--gray--default',
        DARK_1: '--theme-color--gray--dark-1',
        DARK_2: '--theme-color--gray--dark-2',
        DARK_3: '--theme-color--gray--dark-3',
        DARK_4: '--theme-color--gray--dark-4',
    },
    Primary: {
        LIGHT_6: '--theme-color--primary--light-6',
        LIGHT_5: '--theme-color--primary--light-5',
        LIGHT_4: '--theme-color--primary--light-4',
        LIGHT_3: '--theme-color--primary--light-3',
        LIGHT_2: '--theme-color--primary--light-2',
        LIGHT_1: '--theme-color--primary--light-1',
        DEFAULT: '--theme-color--primary--default',
        DARK_1: '--theme-color--primary--dark-1',
        DARK_2: '--theme-color--primary--dark-2',
        DARK_3: '--theme-color--primary--dark-3',
        DARK_4: '--theme-color--primary--dark-4',
    },
    Error: {
        LIGHT_6: '--theme-color--error--light-6',
        LIGHT_5: '--theme-color--error--light-5',
        LIGHT_4: '--theme-color--error--light-4',
        LIGHT_3: '--theme-color--error--light-3',
        LIGHT_2: '--theme-color--error--light-2',
        LIGHT_1: '--theme-color--error--light-1',
        DEFAULT: '--theme-color--error--default',
        DARK_1: '--theme-color--error--dark-1',
        DARK_2: '--theme-color--error--dark-2',
        DARK_3: '--theme-color--error--dark-3',
        DARK_4: '--theme-color--error--dark-4',
    },
    Warning: {
        LIGHT_6: '--theme-color--warning--light-6',
        LIGHT_5: '--theme-color--warning--light-5',
        LIGHT_4: '--theme-color--warning--light-4',
        LIGHT_3: '--theme-color--warning--light-3',
        LIGHT_2: '--theme-color--warning--light-2',
        LIGHT_1: '--theme-color--warning--light-1',
        DEFAULT: '--theme-color--warning--default',
        DARK_1: '--theme-color--warning--dark-1',
        DARK_2: '--theme-color--warning--dark-2',
        DARK_3: '--theme-color--warning--dark-3',
        DARK_4: '--theme-color--warning--dark-4',
    },
    Success: {
        LIGHT_6: '--theme-color--success--light-6',
        LIGHT_5: '--theme-color--success--light-5',
        LIGHT_4: '--theme-color--success--light-4',
        LIGHT_3: '--theme-color--success--light-3',
        LIGHT_2: '--theme-color--success--light-2',
        LIGHT_1: '--theme-color--success--light-1',
        DEFAULT: '--theme-color--success--default',
        DARK_1: '--theme-color--success--dark-1',
        DARK_2: '--theme-color--success--dark-2',
        DARK_3: '--theme-color--success--dark-3',
        DARK_4: '--theme-color--success--dark-4',
    },
};
exports.Gradient = {
    Neutral: {
        NEUTRAL_1: '--gradients--neutral--neutral-1',
        NEUTRAL_2: '--gradients--neutral--neutral-2',
        NEUTRAL_3: '--gradients--neutral--neutral-3',
        NEUTRAL_4: '--gradients--neutral--neutral-4',
        NEUTRAL_5: '--gradients--neutral--neutral-5',
        NEUTRAL_6: '--gradients--neutral--neutral-6',
        NEUTRAL_7: '--gradients--neutral--neutral-7',
        NEUTRAL_8: '--gradients--neutral--neutral-8',
    },
    Primary: {
        PRIMARY_1: '--gradients--primary--primary-1',
        PRIMARY_2: '--gradients--primary--primary-2',
        PRIMARY_3: '--gradients--primary--primary-3',
        PRIMARY_4: '--gradients--primary--primary-4',
        PRIMARY_5: '--gradients--primary--primary-5',
        PRIMARY_6: '--gradients--primary--primary-6',
        PRIMARY_7: '--gradients--primary--primary-7',
    },
    Brand: {
        BRAND_1: '--gradients--brand--brand-1',
        BRAND_2: '--gradients--brand--brand-2',
    },
};
var TextColor;
(function (TextColor) {
    TextColor["HEAD"] = "--text-colors--text-head";
    TextColor["DEFAULT"] = "--text-colors--text-default";
    TextColor["SECONDARY"] = "--text-colors--text-secondary";
    TextColor["DISABLED"] = "--text-colors--text-disabled";
    TextColor["LINK"] = "--text-colors--text-link";
    TextColor["LINK_PRIMARY_LIGHT"] = "--text-colors--text-link-primary-light";
    TextColor["LINK_NEUTRAL"] = "--text-colors--text-link-neutral";
    TextColor["DANGER"] = "--text-colors--text-danger";
    TextColor["WARNING"] = "--text-colors--text-warning";
    TextColor["SUCCESS"] = "--text-colors--text-success";
    TextColor["PRIMARY"] = "--text-colors--text-primary";
})(TextColor = exports.TextColor || (exports.TextColor = {}));
var BorderColor;
(function (BorderColor) {
    BorderColor["GRAY_LIGHT_6"] = "--border-colors--bdr-gray-light-6";
    BorderColor["GRAY_LIGHT_5"] = "--border-colors--bdr-gray-light-5";
    BorderColor["GRAY_LIGHT_4"] = "--border-colors--bdr-gray-light-4";
    BorderColor["GRAY_LIGHT_3"] = "--border-colors--bdr-gray-light-3";
    BorderColor["GRAY_LIGHT_2"] = "--border-colors--bdr-gray-light-2";
    BorderColor["GRAY_LIGHT_1"] = "--border-colors--bdr-gray-light-1";
    BorderColor["GRAY"] = "--border-colors--bdr-gray";
    BorderColor["GRAY_DARK_1"] = "--border-colors--bdr-gray-dark-1";
    BorderColor["GRAY_DARK_2"] = "--border-colors--bdr-gray-dark-2";
    BorderColor["GRAY_DARK_3"] = "--border-colors--bdr-gray-dark-3";
    BorderColor["GRAY_DARK_4"] = "--border-colors--bdr-gray-dark-4";
})(BorderColor = exports.BorderColor || (exports.BorderColor = {}));
var BackgroundColor;
(function (BackgroundColor) {
    BackgroundColor["DISABLED"] = "--bg-colors--bg-disabled";
})(BackgroundColor = exports.BackgroundColor || (exports.BackgroundColor = {}));
exports.ComponentColor = {
    Form: {
        Border: {
            DEFAULT: '--component--form--form-bdr-default',
            HOVER: '--component--form--form-bdr-hover',
            FOCUS: '--component--form--form-bdr-focus',
            DISABLED: '--component--form--form-bdr-disabled',
            READONLY: '--component--form--form-bdr-readonly',
            ERROR_DEFAULT: '--component--form--form-bdr-error-default',
            ERROR_HOVER: '--component--form--form-bdr-error-hover',
            ERROR_FOCUS: '--component--form--form-bdr-error-focus',
        },
        Background: {
            BASE: '--component--form--form-bg-base',
            DISABLED: '--component--form--form-bg-disabled',
            READONLY: '--component--form--form-bg-readonly',
        },
        Text: {
            LABEL: '--component--form--form-txt-label',
            MARK: '--component--form--form-txt-mark',
            HINT: '--component--form--form-txt-hint',
            ERROR_MSG: '--component--form--form-txt-errormsg',
            CHAR_COUNT: '--component--form--form-txt-charcount',
            PLACEHOLDER: '--component--form--form-txt-placeholder',
            FILLED: '--component--form--form-txt-filled',
            DISABLED: '--component--form--form-txt-disabled',
        },
        Icon: {
            BASE: '--component--form--form-icon-base',
            DISABLED: '--component--form--form-icon-disabled',
        },
    },
    Table: {
        Head: {
            Text: {
                DEFAULT: '--component--table--t-head-text-default',
                ACTIVE: '--component--table--t-head-text-active',
            },
        },
    },
    InputNumber: {
        Handler: {
            Border: {
                BASE: '--component--inputnumber--handler-bdr-base',
            },
            Icon: {
                DEFAULT: '--component--inputnumber--handler-icon-default',
                HOVER: '--component--inputnumber--handler-icon-hover',
                PRESSED: '--component--inputnumber--handler-icon-pressed',
                DISABLED: '--component--inputnumber--handler-icon-disabled',
            },
            Background: {
                BASE: '--component--inputnumber--handler-bg-base',
                DISABLED: '--component--inputnumber--handler-bg-disabled',
                PRESSED: '--component--inputnumber--handler-bg-pressed',
            },
        },
    },
    Button: {
        Background: {
            PRIMARY_DEFAULT: '--component--button--btn-bg-primary-default',
            PRIMARY_HOVER: '--component--button--btn-bg-primary-hover',
            PRIMARY_FOCUS: '--component--button--btn-bg-primary-focus',
            PRIMARY_DISABLED: '--component--button--btn-bg-primary-disabled',
            DSTR_PRIMARY_DEFAULT: '--component--button--btn-bg-dstr-primary-default',
            DSTR_PRIMARY_HOVER: '--component--button--btn-bg-dstr-primary-hover',
            DSTR_PRIMARY_FOCUS: '--component--button--btn-bg-dstr-primary-focus',
            DSTR_PRIMARY_DISABLED: '--component--button--btn-bg-dstr-primary-disabled',
            SECONDARY_DEFAULT: '--component--button--btn-bg-secondary-default',
            SECONDARY_HOVER: '--component--button--btn-bg-secondary-hover',
            SECONDARY_FOCUS: '--component--button--btn-bg-secondary-focus',
            SECONDARY_DISABLED: '--component--button--btn-bg-secondary-disabled',
            DSTR_SECONDARY_DEFAULT: '--component--button--btn-bg-dstr-secondary-default',
            DSTR_SECONDARY_HOVER: '--component--button--btn-bg-dstr-secondary-hover',
            DSTR_SECONDARY_FOCUS: '--component--button--btn-bg-dstr-secondary-focus',
            DSTR_SECONDARY_DISABLED: '--component--button--btn-bg-dstr-secondary-disabled',
        },
        Border: {
            PRIMARY_DEFAULT: '--component--button--btn-bdr-primary-default',
            PRIMARY_HOVER: '--component--button--btn-bdr-primary-hover',
            PRIMARY_FOCUS: '--component--button--btn-bdr-primary-focus',
            PRIMARY_DISABLED: '--component--button--btn-bdr-primary-disabled',
            DSTR_PRIMARY_DEFAULT: '--component--button--btn-bdr-dstr-primary-default',
            DSTR_PRIMARY_HOVER: '--component--button--btn-bdr-dstr-primary-hover',
            DSTR_PRIMARY_FOCUS: '--component--button--btn-bdr-dstr-primary-focus',
            DSTR_PRIMARY_DISABLED: '--component--button--btn-bdr-dstr-primary-disabled',
            SECONDARY_DEFAULT: '--component--button--btn-bdr-secondary-default',
            SECONDARY_HOVER: '--component--button--btn-bdr-secondary-hover',
            SECONDARY_FOCUS: '--component--button--btn-bdr-secondary-focus',
            SECONDARY_DISABLED: '--component--button--btn-bdr-secondary-disabled',
            DSTR_SECONDARY_DEFAULT: '--component--button--btn-bdr-dstr-secondary-default',
            DSTR_SECONDARY_HOVER: '--component--button--btn-bdr-dstr-secondary-hover',
            DSTR_SECONDARY_FOCUS: '--component--button--btn-bdr-dstr-secondary-focus',
            DSTR_SECONDARY_DISABLED: '--component--button--btn-bdr-dstr-secondary-disabled',
        },
        Text: {
            PRIMARY_DEFAULT: '--component--button--btn-txt-primary-default',
            PRIMARY_HOVER: '--component--button--btn-txt-primary-hover',
            PRIMARY_FOCUS: '--component--button--btn-txt-primary-focus',
            PRIMARY_DISABLED: '--component--button--btn-txt-primary-disabled',
            DSTR_PRIMARY_DEFAULT: '--component--button--btn-txt-dstr-primary-default',
            DSTR_PRIMARY_HOVER: '--component--button--btn-txt-dstr-primary-hover',
            DSTR_PRIMARY_FOCUS: '--component--button--btn-txt-dstr-primary-focus',
            DSTR_PRIMARY_DISABLED: '--component--button--btn-txt-dstr-primary-disabled',
            SECONDARY_DEFAULT: '--component--button--btn-txt-secondary-default',
            SECONDARY_HOVER: '--component--button--btn-txt-secondary-hover',
            SECONDARY_FOCUS: '--component--button--btn-txt-secondary-focus',
            SECONDARY_DISABLED: '--component--button--btn-txt-secondary-disabled',
            DSTR_SECONDARY_DEFAULT: '--component--button--btn-txt-dstr-secondary-default',
            DSTR_SECONDARY_HOVER: '--component--button--btn-txt-dstr-secondary-hover',
            DSTR_SECONDARY_FOCUS: '--component--button--btn-txt-dstr-secondary-focus',
            DSTR_SECONDARY_DISABLED: '--component--button--btn-txt-dstr-secondary-disabled',
        },
        Icon: {
            PRIMARY_DEFAULT: '--component--button--btn-icon-primary-default',
            PRIMARY_HOVER: '--component--button--btn-icon-primary-hover',
            PRIMARY_FOCUS: '--component--button--btn-icon-primary-focus',
            PRIMARY_DISABLED: '--component--button--btn-icon-primary-disabled',
            DSTR_PRIMARY_DEFAULT: '--component--button--btn-icon-dstr-primary-default',
            DSTR_PRIMARY_HOVER: '--component--button--btn-icon-dstr-primary-hover',
            DSTR_PRIMARY_FOCUS: '--component--button--btn-icon-dstr-primary-focus',
            DSTR_PRIMARY_DISABLED: '--component--button--btn-icon-dstr-primary-disabled',
            SECONDARY_DEFAULT: '--component--button--btn-icon-secondary-default',
            SECONDARY_HOVER: '--component--button--btn-icon-secondary-hover',
            SECONDARY_FOCUS: '--component--button--btn-icon-secondary-focus',
            SECONDARY_DISABLED: '--component--button--btn-icon-secondary-disabled',
            DSTR_SECONDARY_DEFAULT: '--component--button--btn-icon-dstr-secondary-default',
            DSTR_SECONDARY_HOVER: '--component--button--btn-icon-dstr-secondary-hover',
            DSTR_SECONDARY_FOCUS: '--component--button--btn-icon-dstr-secondary-focus',
            DSTR_SECONDARY_DISABLED: '--component--button--btn-icon-dstr-secondary-disabled',
        },
    },
};
var Shadow;
(function (Shadow) {
    Shadow["sm"] = "--shadow-sm";
    Shadow["md"] = "--shadow-md";
    Shadow["lg"] = "--shadow-lg";
    Shadow["xl"] = "--shadow-xl";
    Shadow["xxl"] = "--shadow-2xl";
})(Shadow = exports.Shadow || (exports.Shadow = {}));
var Focus;
(function (Focus) {
    Focus["PRIMARY_LIGHT"] = "--focus--primary-light";
    Focus["PRIMARY"] = "--focus--primary";
    Focus["GRAY_LIGHT"] = "--focus--gray-light";
    Focus["GRAY"] = "--focus--gray";
    Focus["ERROR_LIGHT"] = "--focus--error-light";
    Focus["ERROR"] = "--focus--error";
    Focus["SUCCESS_LIGHT"] = "--focus--success-light";
    Focus["SUCCESS"] = "--focus--success";
})(Focus = exports.Focus || (exports.Focus = {}));
